// @ts-ignore
import $ from "jquery";

const debug = {
    dev: false,
    head: 'LAYOUT.analytics'
};

export default class LayoutAnalytics {

    public $analytics   : any

    constructor() {

        if (debug.dev) console.log(debug.head, ".constructor");

        this.$analytics = null;
    }

    open() {

        if (!this.$analytics) this.$analytics = $("#ui-analytics");

        this.$analytics.addClass('open');
    }

    openFullScreenApp() {

        if (!this.$analytics) this.$analytics = $("#ui-analytics");

        this.$analytics.addClass('open-full-screen');
    }

    close() {
        if (!this.$analytics) this.$analytics = $("#ui-analytics");

        this.$analytics.removeClass('open');
        this.$analytics.removeClass('open-full-screen');
    }

}
